export const billingExplorerChartValuesPercentFormater = (
  value: number | string,
) => `${(+value).toFixed(2)}%`;
